(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var nodes = document.querySelectorAll(
    ".bls__product-item, .bls__banner, .collection-item, .blog-card, .article-card, .bls__section-header, .icon-box"
  );
  if (!nodes.length || !("IntersectionObserver" in window)) return;

  nodes.forEach(function (el, i) {
    el.classList.add("muki-fade-up");
    el.style.transitionDelay = (i % 6) * 60 + "ms";
  });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
  );

  nodes.forEach(function (el) {
    io.observe(el);
  });
})();


(function () {
  function hideZeroPrices(root) {
    (root || document).querySelectorAll(".bls__product-item, .product__info-container, product-info, .bls__product-details").forEach(function (card) {
      var priceEls = card.querySelectorAll(".bls__product-price, .price, [data-product-price], .price__regular, .price-item");
      var hide = false;
      priceEls.forEach(function (el) {
        var t = (el.textContent || "").replace(/\s+/g, " ").trim();
        // $0 / $0.00 / $ 0 / 0
        if (/^(\$|\$\s*)?0([.,]0+)?(\s*CLP)?$/i.test(t) || t === "$0" || t === "$0.00" || t === "0" || /^\$\s*0([.,]00)?$/.test(t)) {
          hide = true;
        }
        if ((el.getAttribute("content") || "") === "0" || (el.getAttribute("data-price") || "") === "0") hide = true;
      });
      if (hide) {
        card.classList.add("muki-price-hidden");
        priceEls.forEach(function (el) {
          var box = el.closest(".bls__product-price, .price") || el;
          box.style.display = "none";
        });
      }
    });
  }
  hideZeroPrices();
  document.addEventListener("shopify:section:load", function () { hideZeroPrices(); });
  setTimeout(function () { hideZeroPrices(); }, 800);
  setTimeout(function () { hideZeroPrices(); }, 2000);
})();

(function () {
  function cartEl() {
    return document.getElementById("bls-header_minicart");
  }
  function cartIsOpen() {
    var el = cartEl();
    return !!(el && el.classList.contains("bls__opend-popup-header"));
  }
  function overlay() {
    return document.querySelector(".bls__overlay");
  }
  function setOverlay(active) {
    var ov = overlay();
    if (!ov) return;
    if (active) {
      ov.classList.add("muki-cart-overlay-active");
      ov.classList.remove("d-none-overlay");
    } else {
      ov.classList.remove("muki-cart-overlay-active");
      ov.classList.add("d-none-overlay");
    }
  }
  function killMasks() {
    document.querySelectorAll("#dlg-mask, .dlg-mask, [id*='dlgmask']").forEach(function (el) {
      try { el.remove(); } catch (e) {}
    });
  }
  function closeCartClean() {
    var el = cartEl();
    if (el) el.classList.remove("bls__opend-popup-header", "start", "loading", "finish");
    document.documentElement.classList.remove("hside_opened", "overflow-hidden", "modal-open");
    document.body.classList.remove("overflow-hidden", "modal-open", "bls-overflow-hidden", "open-popup");
    document.body.style.pointerEvents = "auto";
    setOverlay(false);
    killMasks();
    var cn = document.querySelector("cart-notification");
    if (cn && typeof cn.close === "function") {
      try { cn.close(); } catch (e) {}
    }
  }

  // Cart icon → always go to /cart (drawer is unreliable)
  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest && e.target.closest("#cart-icon-bubble, a.bls-minicart-action");
      if (!btn) return;
      // allow close-cart buttons inside drawer
      if (btn.classList.contains("close-cart")) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = "/cart";
    },
    true
  );

  // Overlay / Escape close drawer if it did open
  document.addEventListener(
    "click",
    function (e) {
      if (e.target.closest && e.target.closest(".bls__overlay")) {
        e.preventDefault();
        e.stopPropagation();
        closeCartClean();
      }
    },
    true
  );
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeCartClean();
  });
  document.addEventListener(
    "click",
    function (e) {
      if (e.target.closest("#bls-header_minicart .close-button, #bls-header_minicart .button-close, .close-cart")) {
        setTimeout(closeCartClean, 10);
      }
    },
    true
  );

  // Enable checkout if stuck disabled without terms
  function unlockCheckout() {
    document.querySelectorAll(".bls-btn-checkout[disabled], .bls__payment-button.disabled").forEach(function (el) {
      el.removeAttribute("disabled");
      el.classList.remove("disabled");
    });
  }
  unlockCheckout();
  setTimeout(unlockCheckout, 500);

  // Start closed (no auto-open)
  closeCartClean();

  var el = cartEl();
  if (el && window.MutationObserver) {
    new MutationObserver(function () {
      if (cartIsOpen()) {
        document.documentElement.classList.add("hside_opened");
        setOverlay(true);
        unlockCheckout();
        // If drawer opened but has no visible line items, send user to /cart
        setTimeout(function () {
          if (!cartIsOpen()) return;
          var items = el.querySelectorAll(".bls-items .cart-item, .bls-minicart-body .cart-item");
          var countEl = el.querySelector(".cart-count, .cart-count-drawer");
          var countTxt = countEl ? (countEl.textContent || "") : "";
          var n = parseInt(countTxt.replace(/[^0-9]/g, ""), 10) || 0;
          if (n > 0 && items.length === 0) {
            window.location.href = "/cart";
          }
        }, 200);
      } else {
        document.documentElement.classList.remove("hside_opened");
        setOverlay(false);
      }
    }).observe(el, { attributes: true, attributeFilter: ["class"] });
  }
})();

